import s from "./styles.module.sass";
import Testimonial from "@shared/UI/Testimonial";
import { useStore } from "effector-react";
import { $reviewsResponse } from "@features/Reviews/model/private";

const CourseTestimonials = () => {
	const courseReviews = useStore($reviewsResponse);

	const hasTestimonials = courseReviews?.totalCount !== 0;

	return (
		<section className={s.courseTestimonials}>
			<h2 className={s.title}>Отзывы учеников</h2>
			{!hasTestimonials ? (
				<div className={s.noTestimonials}>
					<p>У этого курса пока нет отзывов</p>
				</div>
			) : (
				courseReviews?.items?.map((review) => {
					return (
						<div key={review.id} className={s.testimonialWrapper}>
							<Testimonial key={review.id} testimonial={review} />
						</div>
					);
				})
			)}
		</section>
	);
};

export default CourseTestimonials;
